module.exports = __webpack_public_path__ + "static/media/empty_rewards.23396606.png";